import { AppRouteRecordRaw } from '../types';
import { PARTNER_FEATURE_FLAGS } from '@/constants/partner-features';

const Body = () => import('@/components/body.vue');
const PartnerDocuments = () => import('@/pages/documents/PartnerDocuments.vue');
const PartnerDocumentView = () => import('@/pages/documents/PartnerDocumentView.vue');

export const documentsRoutes: AppRouteRecordRaw[] = [
  {
    path: '/documents',
    component: Body,
    meta: {
      breadcrumb: 'Documents',
    },
    children: [
      {
        path: '',
        name: 'partnerDocuments',
        component: PartnerDocuments,
        meta: {
          title: 'Documents | ryd Portal',
          breadcrumb: 'Documents',
          requiresAuth: true,
          requiresPartnerFeature: PARTNER_FEATURE_FLAGS.DOCUMENTS,
        },
      },
      {
        // Full-page document view for partner users; shared links
        // (/documents?document=<id>) are forwarded here by the router guard.
        path: 'view/:documentId',
        name: 'partnerDocumentView',
        component: PartnerDocumentView,
        meta: {
          title: 'Document | ryd Portal',
          breadcrumb: 'Document',
          requiresAuth: true,
          requiresPartnerFeature: PARTNER_FEATURE_FLAGS.DOCUMENTS,
        },
      },
    ],
  },
  {
    path: '/account-management/documents',
    redirect: '/documents',
  },
];
